
declare let Camera: any;
declare let navigator: any;

const uriToBlob = (uri: string): Promise<Blob> => {
  return new Promise((resolve, reject) => {
    const w: any = window;

    const readFromUri = (u: string) => {
      if (!w.resolveLocalFileSystemURL) {
        reject(new Error("resolveLocalFileSystemURL missing (cordova-plugin-file not installed)"));
        return;
      }

      w.resolveLocalFileSystemURL(
        u,
        (entry: any) => {
          entry.file(
            (file: any) => {
              const reader = new FileReader();
              reader.onloadend = () => {
                const ab = reader.result as ArrayBuffer;
                resolve(new Blob([ab], { type: file.type || "image/jpeg" }));
              };
              reader.onerror = () => reject(new Error("FileReader failed"));
              reader.readAsArrayBuffer(file);
            },
            (err: any) => reject(new Error("entry.file failed: " ))
          );
        },
        (err: any) => reject(new Error("resolveLocalFileSystemURL failed: " ))
      );
    };

    // If you ever get content:// and you installed cordova-plugin-filepath
    if (uri.startsWith("content://") && w.FilePath?.resolveNativePath) {
      w.FilePath.resolveNativePath(
        uri,
        (nativePath: string) => readFromUri(nativePath),
        (e: any) => reject(new Error("resolveNativePath failed: " + (e?.message || JSON.stringify(e))))
      );
      return;
    }

    readFromUri(uri);
  });
};

export const getPicture = (
  source: "CAMERA",
  success: (blob: Blob) => void,
  error: (message: string) => void
) => {
  const options = {
    quality: 80,
    destinationType: Camera.DestinationType.FILE_URI, // ✅ key change
    sourceType: Camera.PictureSourceType.CAMERA,
    encodingType: Camera.EncodingType.JPEG,
    mediaType: Camera.MediaType.PICTURE,
    cameraDirection: 0,
    correctOrientation: true,
    targetHeight: 1000,
    targetWidth: 1000,
    saveToPhotoAlbum: false,
  };

  navigator.camera.getPicture(
    async (imageUri: string) => {
      try {
        const blob = await uriToBlob(imageUri);
        success(blob);
      } catch (e) {
        error("Failed to read camera image: " + (e?.message || String(e)));
      }
    },
    (e: any) => error(typeof e === "string" ? e : JSON.stringify(e)),
    options
  );
};



// WEBPACK FOOTER //
// ./src/helpers/cameraHelper.ts